import { render, staticRenderFns } from "./AdvisorView.vue?vue&type=template&id=244ed4ef"
import script from "./AdvisorView.vue?vue&type=script&lang=js"
export * from "./AdvisorView.vue?vue&type=script&lang=js"
import style0 from "./AdvisorView.vue?vue&type=style&index=0&id=244ed4ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports